const TP_TAXA_NAO_SE_APLICA = 1;
const STATUS_ATIVO = 1;

export const TAXA_TIPO_FIELDS = ["tp_taxa_tde", "tp_taxa_tda", "tp_taxa_pedagio"];

export const TAXA_VALUE_FIELDS = [
  "taxa_tda",
  "taxa_tde",
  "vlr_fixo_tda",
  "vlr_fixo_tde",
  "taxa_pedagio",
  "vlr_pedagio",
  "taxa_gris",
  "taxa_devolucao",
  "taxa_reentrega",
  "vlr_tas",
  "vlr_despacho",
  "vlr_sec_cat",
  "vlr_agendamento",
  "vlr_outros",
  "taxa_coleta",
  "vlr_minimo_gris",
  "ad_valorem",
  "vlr_minimo_advalorem",
  "vlr_min_nota_cte",
  "vlr_qtde_docs_fiscais",
];

export const TAXA_DEFAULTS = {
  tp_taxa_tda: null,
  tp_taxa_tde: null,
  tp_taxa_pedagio: null,
  taxa_tda: 0,
  taxa_tde: 0,
  vlr_fixo_tda: 0,
  vlr_fixo_tde: 0,
  taxa_pedagio: 0,
  vlr_pedagio: 0,
  taxa_gris: 0,
  taxa_devolucao: 0,
  taxa_reentrega: 0,
  vlr_tas: 0,
  vlr_despacho: 0,
  vlr_sec_cat: 0,
  vlr_agendamento: 0,
  vlr_outros: 0,
  taxa_coleta: 0,
  vlr_minimo_gris: 0,
  ad_valorem: 0,
  vlr_minimo_advalorem: 0,
  vlr_min_nota_cte: 0,
  vlr_qtde_docs_fiscais: 0,
  qtde_docs_fiscais: null,
};

export const CUSTO_EXTRA_LIMIT = 20;

export const DUPLICATE_CUSTO_MESSAGE =
  "Custo informado mais de uma vez para o mesmo trecho.";

function isBlank(value) {
  return value === null || value === undefined || value === "";
}

function toNumber(value, fallback) {
  if (isBlank(value)) return fallback;
  const number = Number(value);
  return isNaN(number) ? fallback : number;
}

export function createEmptyCustoExtra() {
  return {
    tp_trecho: null,
    tp_trecho_custo: null,
    vlr_taxa: 0,
    taxa_comissao: 0,
    vlr_minimo: 0,
    custo_id: null,
  };
}

export function isCustoExtraComplete(custo) {
  return (
    custo != null &&
    custo.tp_trecho != null &&
    custo.tp_trecho_custo != null &&
    custo.custo_id != null &&
    custo.vlr_taxa != null &&
    custo.vlr_taxa !== ""
  );
}

export function isCustoExtraBlank(custo) {
  if (!custo) return true;
  return (
    isBlank(custo.tp_trecho) &&
    isBlank(custo.tp_trecho_custo) &&
    isBlank(custo.custo_id) &&
    !toNumber(custo.vlr_taxa, 0) &&
    !toNumber(custo.taxa_comissao, 0) &&
    !toNumber(custo.vlr_minimo, 0)
  );
}

export function createEmptyTaxas() {
  return { ...TAXA_DEFAULTS, custo_extra: [] };
}

export function copyTaxas(source) {
  const base = source || {};
  const taxas = createEmptyTaxas();

  Object.keys(TAXA_DEFAULTS).forEach((campo) => {
    if (base[campo] !== undefined) taxas[campo] = base[campo];
  });
  taxas.custo_extra = (base.custo_extra || [])
    .filter((custo) => !isCustoExtraBlank(custo))
    .map((custo) => ({ ...createEmptyCustoExtra(), ...custo }));

  return taxas;
}

export function mapTaxasToApi(taxes) {
  const source = taxes || {};
  const payload = {};

  TAXA_TIPO_FIELDS.forEach((campo) => {
    payload[campo] = { value: toNumber(source[campo], TP_TAXA_NAO_SE_APLICA) };
  });
  TAXA_VALUE_FIELDS.forEach((campo) => {
    payload[campo] = toNumber(source[campo], 0);
  });
  payload.qtde_docs_fiscais = toNumber(source.qtde_docs_fiscais, null);

  return payload;
}

export function mapCustosExtraToApi(custos) {
  return (custos || []).filter(isCustoExtraComplete).map((custo) => ({
    tp_trecho: { value: toNumber(custo.tp_trecho, null) },
    tp_trecho_custo: { value: toNumber(custo.tp_trecho_custo, null) },
    custo: { value: toNumber(custo.custo_id, null) },
    vlr_taxa: toNumber(custo.vlr_taxa, 0),
    taxa_comissao: toNumber(custo.taxa_comissao, 0),
    vlr_minimo: toNumber(custo.vlr_minimo, 0),
    status: 1,
  }));
}

export function findCustoExtraIssues(custos, options) {
  const excludedTrechos = ((options && options.excludedTrechos) || []).map(Number);
  const excludedMessage = (options && options.excludedMessage) || "";
  const issues = {};
  const seen = {};

  (custos || []).forEach((custo, index) => {
    if (isCustoExtraBlank(custo)) return;

    if (
      !isBlank(custo.tp_trecho) &&
      excludedTrechos.indexOf(Number(custo.tp_trecho)) !== -1
    ) {
      issues[index] = { ...(issues[index] || {}), tp_trecho: excludedMessage };
    }

    if (!isCustoExtraComplete(custo)) return;

    const key = [custo.custo_id, custo.tp_trecho, custo.tp_trecho_custo]
      .map(Number)
      .join("|");
    if (seen[key]) {
      issues[index] = {
        ...(issues[index] || {}),
        custo_id: DUPLICATE_CUSTO_MESSAGE,
      };
    }
    seen[key] = true;
  });

  return issues;
}

export function areCustosExtraReady(custos, options) {
  const list = (custos || []).filter((custo) => !isCustoExtraBlank(custo));
  if (list.length > CUSTO_EXTRA_LIMIT) return false;
  if (!list.every(isCustoExtraComplete)) return false;
  return !Object.keys(findCustoExtraIssues(custos, options)).length;
}

export function sentCustoExtraIndexes(custos) {
  return (custos || []).reduce(
    (indexes, custo, index) =>
      isCustoExtraComplete(custo) ? indexes.concat([index]) : indexes,
    [],
  );
}

function scalarOf(raw, key) {
  const value = raw ? raw[key] : null;
  if (value && typeof value === "object") {
    return value.valor === undefined ? null : toNumber(value.valor, null);
  }
  return toNumber(value, null);
}

function activeRate(rawTaxa) {
  if (!rawTaxa) return null;
  if (!Array.isArray(rawTaxa)) return rawTaxa;

  return (
    rawTaxa
      .filter((taxa) => scalarOf(taxa, "status") === STATUS_ATIVO)
      .sort((a, b) => Number(b.tafrvita_id) - Number(a.tafrvita_id))[0] || null
  );
}

export function mapTaxasFromLegacyApi(rawTaxa, rawCustos) {
  const taxa = activeRate(rawTaxa);
  const taxas = createEmptyTaxas();

  if (taxa) {
    TAXA_TIPO_FIELDS.forEach((campo) => {
      taxas[campo] = scalarOf(taxa, campo);
    });
    TAXA_VALUE_FIELDS.forEach((campo) => {
      taxas[campo] = toNumber(taxa[campo], 0);
    });
    taxas.qtde_docs_fiscais = toNumber(taxa.qtde_docs_fiscais, null);
  }

  taxas.custo_extra = (rawCustos || [])
    .filter((custo) => scalarOf(custo, "status") === STATUS_ATIVO)
    .sort((a, b) => Number(a.tafrvce_id) - Number(b.tafrvce_id))
    .map((custo) => ({
      tp_trecho: scalarOf(custo, "tp_trecho"),
      tp_trecho_custo: scalarOf(custo, "tp_trecho_custo"),
      custo_id: toNumber(custo.custo_id, null),
      vlr_taxa: toNumber(custo.vlr_taxa, 0),
      taxa_comissao: toNumber(custo.taxa_comissao, 0),
      vlr_minimo: toNumber(custo.vlr_minimo, 0),
    }));

  return taxas;
}
